import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-wrap -mx-2" }
const _hoisted_3 = { class: "w-full lg:w-12/12 order-2 lg:order-1 px-2" }
const _hoisted_4 = { class: "mb-4 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "border-l-4 border-purple-500 bg-gradient-to-r from-purple-50 to-pink-50 p-4 mt-5 sm:mt-0 shadow-sm rounded-lg"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "ml-3 flex-1" }
const _hoisted_8 = { class: "text-sm font-bold text-purple-900" }
const _hoisted_9 = { class: "text-sm text-purple-800 mt-1" }
const _hoisted_10 = { class: "mt-3 flex flex-col sm:flex-row sm:items-center gap-3" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "border-l-4 border-yellow-400 bg-yellow-50 p-4 mt-5 sm:mt-0"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = { class: "text-sm text-yellow-700" }
const _hoisted_16 = { class: "w-full flex items-center justify-items-between sm:border-b border-gray-200 mt-5 gap-1 sm:gap-0 sm:mt-0" }
const _hoisted_17 = {
  class: "-mb-px flex space-x-4 sm:space-x-8",
  "aria-label": "Tabs"
}
const _hoisted_18 = ["onClick", "aria-current"]
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "me-2 hidden sm:block"
}
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 1,
  class: "ml-auto sm:hidden items-center rounded-lg bg-gray-100 flex p-0.5"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "py-1" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "ml-auto items-center rounded-md bg-white p-0.5 flex gap-0.5" }
const _hoisted_27 = {
  key: 0,
  class: "grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-4 lg:grid-cols-4 lg:gap-x-4"
}
const _hoisted_28 = { class: "rounded-md bg-yellow-50 p-4 col-span-4" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "shrink-0" }
const _hoisted_31 = { class: "ml-3" }
const _hoisted_32 = { class: "text-sm font-medium text-yellow-800" }
const _hoisted_33 = {
  key: 1,
  class: "grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-4 lg:grid-cols-4 lg:gap-x-4"
}
const _hoisted_34 = {
  key: 2,
  class: "grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-4 lg:grid-cols-4 lg:gap-x-4"
}
const _hoisted_35 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_36 = { class: "mt-2 block text-sm font-semibold text-gray-900" }
const _hoisted_37 = {
  key: 1,
  class: "col-span-1 sm:col-span-2 lg:col-span-4"
}
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = {
  ref: "scrollSentinel",
  class: "h-px w-full"
}
const _hoisted_42 = {
  key: 6,
  class: "flex justify-center py-6"
}
const _hoisted_43 = {
  key: 7,
  class: "flex justify-center py-6"
}
const _hoisted_44 = { class: "w-full lg:w-4/12 order-1 lg:order-2 mb-3 px-2 hidden" }
const _hoisted_45 = { class: "sticky top-20" }
const _hoisted_46 = { class: "rounded-md bg-royal-blue-50 p-4 shadow-sm" }
const _hoisted_47 = { class: "flex" }
const _hoisted_48 = { class: "shrink-0" }
const _hoisted_49 = {
  key: 0,
  class: "bg-white shadow rounded-lg mt-4"
}
const _hoisted_50 = { class: "p-4" }
const _hoisted_51 = { class: "w-full bg-gray-200 h-2 rounded" }
const _hoisted_52 = { class: "flex justify-between items-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_BarsArrowDownIcon = _resolveComponent("BarsArrowDownIcon")!
  const _component_ChevronDownIcon20 = _resolveComponent("ChevronDownIcon20")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Bars4Icon = _resolveComponent("Bars4Icon")!
  const _component_Squares2X2IconMini = _resolveComponent("Squares2X2IconMini")!
  const _component_ExclamationTriangleIcon = _resolveComponent("ExclamationTriangleIcon")!
  const _component_GalleryCardGridItemComponent = _resolveComponent("GalleryCardGridItemComponent")!
  const _component_GalleryItemLoaderComponent = _resolveComponent("GalleryItemLoaderComponent")!
  const _component_GalleryListLoaderComponent = _resolveComponent("GalleryListLoaderComponent")!
  const _component_GalleryListComponent = _resolveComponent("GalleryListComponent")!
  const _component_InformationCircleIcon = _resolveComponent("InformationCircleIcon")!
  const _component_DeleteGalleryConfirmationModalComponent = _resolveComponent("DeleteGalleryConfirmationModalComponent")!
  const _component_CreateGalleryComponent = _resolveComponent("CreateGalleryComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.blackFridayUpgradeAvailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "shrink-0" }, [
                      _createElementVNode("span", { class: "text-3xl" }, "🛍️")
                    ], -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, " ⚡ " + _toDisplayString(_ctx.$t('subscription.black_friday.banner_title')), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('subscription.black_friday.banner_description')), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_router_link, {
                          to: "/subscription",
                          class: "inline-flex items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-md hover:from-purple-700 hover:to-pink-700 transition-all"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 🌟 " + _toDisplayString(_ctx.$t('subscription.black_friday.upgrade_button')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("a", {
                          href: _ctx.blackFridayTermsUrl,
                          target: "_blank",
                          class: "text-sm font-medium text-purple-700 hover:text-purple-900 hover:underline transition-all cursor-pointer"
                        }, _toDisplayString(_ctx.$t('subscription.black_friday.terms_button')), 9, _hoisted_11)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.storageUsedPercent >= 90 && !_ctx.blackFridayUpgradeAvailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "shrink-0" }, [
                      _createElementVNode("svg", {
                        class: "size-5 text-yellow-400",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        "aria-hidden": "true",
                        "data-slot": "icon"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                          "clip-rule": "evenodd"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t('home.storage_warning')) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.storageUsed), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('home.of')) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.storageLimit), 1),
                        _cache[12] || (_cache[12] = _createTextVNode(". ")),
                        _createVNode(_component_router_link, {
                          to: "/subscription",
                          class: "font-medium text-yellow-700 underline hover:text-yellow-600"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('home.increase_storage')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass({'w-full -mb-1 sm:mb-0': true, 'hidden': _ctx.isMobileSearchOpened})
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("nav", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: tab.name,
                          href: "#",
                          onClick: _withModifiers(tab.action, ["prevent"]),
                          class: _normalizeClass([tab.current ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700', 'flex border-b-2 px-1 py-2 sm:py-4 text-sm font-medium whitespace-nowrap']),
                          "aria-current": tab.current ? 'page' : undefined
                        }, [
                          _createTextVNode(_toDisplayString(tab.name) + " ", 1),
                          (tab.count)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([tab.current ? 'bg-blue-100 text-blue-700' : 'bg-gray-200 text-gray-900', 'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block'])
                              }, _toDisplayString(tab.count), 3))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_18))
                      }), 128))
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass({'w-full': true, 'hidden': !_ctx.isMobileSearchOpened})
              }, [
                _withDirectives(_createElementVNode("input", {
                  id: "search",
                  name: "search",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  placeholder: _ctx.$t('home.search_placeholder'),
                  class: "block w-full rounded-md bg-white px-2.5 py-1 text-base text-gray-900 outline-1 -outline-offset-1 outline-white shadow.xs placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-500 sm:text-sm/6 focus:bg-white"
                }, null, 8, _hoisted_19), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ], 2),
              (!_ctx.showDeletedList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      id: "search",
                      name: "search",
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                      placeholder: _ctx.$t('home.search_placeholder'),
                      class: "block w-full rounded-md bg-white px-2.5 py-1 text-base text-gray-900 outline-1 -outline-offset-1 outline-white shadow.xs placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-500 sm:text-sm/6 focus:bg-white"
                    }, null, 8, _hoisted_21), [
                      [_vModelText, _ctx.searchQuery]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showDeletedList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isMobileSearchOpened = !_ctx.isMobileSearchOpened), ["prevent"])),
                      type: "button",
                      class: _normalizeClass(['bg-white shadow-xs', 'cursor-pointer rounded-md p-1.5 text-gray-400 hover:bg-white hover:shadow-xs'])
                    }, [
                      (!_ctx.isMobileSearchOpened)
                        ? (_openBlock(), _createBlock(_component_MagnifyingGlassIcon, {
                            key: 0,
                            class: "size-5",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isMobileSearchOpened)
                        ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                            key: 1,
                            class: "size-5",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true),
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "sr-only" }, "Use list view", -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showDeletedList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_Menu, {
                      as: "div",
                      class: "relative inline-block text-left sm:mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_MenuButton, { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white p-1.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 cursor-pointer" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BarsArrowDownIcon, {
                                class: "size-5 text-gray-400",
                                "aria-hidden": "true"
                              }),
                              _createVNode(_component_ChevronDownIcon20, {
                                class: "-mr-1 size-5 text-gray-400 hidden",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_Transition, {
                          "enter-active-class": "transition ease-out duration-100",
                          "enter-from-class": "transform opacity-0 scale-95",
                          "enter-to-class": "transform opacity-100 scale-100",
                          "leave-active-class": "transition ease-in duration-75",
                          "leave-from-class": "transform opacity-100 scale-100",
                          "leave-to-class": "transform opacity-0 scale-95"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_MenuItem, {
                                      key: option.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.order_by = option.value),
                                          class: _normalizeClass([_ctx.order_by == option.value ? 'bg-gray-100 text-gray-900 outline-hidden' : 'text-gray-700', 'hover:bg-gray-50 block px-4 py-2 text-sm'])
                                        }, _toDisplayString(option.name), 11, _hoisted_25)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.layout = 'list'), ["prevent"])),
                  type: "button",
                  class: _normalizeClass([_ctx.layout === 'list' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600', 'cursor-pointer rounded-md p-1 transition-all duration-150'])
                }, [
                  _createVNode(_component_Bars4Icon, {
                    class: "size-5",
                    "aria-hidden": "true"
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "sr-only" }, "Use list view", -1))
                ], 2),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.layout = 'grid'), ["prevent"])),
                  type: "button",
                  class: _normalizeClass([_ctx.layout === 'grid' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600', 'cursor-pointer rounded-md p-1 transition-all duration-150'])
                }, [
                  _createVNode(_component_Squares2X2IconMini, {
                    class: "size-5",
                    "aria-hidden": "true"
                  }),
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sr-only" }, "Use grid view", -1))
                ], 2)
              ])
            ])
          ]),
          (!_ctx.isLoadingGalleries && _ctx.showDeletedList && _ctx.deletedGalleries.length && _ctx.layout === 'grid')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_ExclamationTriangleIcon, {
                        class: "size-5 text-yellow-400",
                        "aria-hidden": "true"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.$t('home.deletion_tip')), 1)
                    ])
                  ])
                ]),
                (_ctx.deletedGalleries.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.deletedGalleries, (item) => {
                      return (_openBlock(), _createBlock(_component_GalleryCardGridItemComponent, {
                        gallery: item,
                        key: `deleting-gallery-item-${item.slug}`,
                        "is-deleting": true,
                        onRestoreGallery: ($event: any) => (_ctx.restore(item.slug)),
                        onDeleteGallery: ($event: any) => (_ctx.deleteFromDeletedList(item.slug))
                      }, null, 8, ["gallery", "onRestoreGallery", "onDeleteGallery"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoadingGalleries && !_ctx.showDeletedList && _ctx.layout === 'grid')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                  return _createVNode(_component_GalleryItemLoaderComponent, {
                    key: `gallery-loader-${i}`
                  })
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoadingGalleries && !_ctx.showDeletedList && _ctx.layout === 'grid')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleries, (gallery) => {
                  return (_openBlock(), _createBlock(_component_GalleryCardGridItemComponent, {
                    gallery: gallery,
                    key: `gallery-item-${gallery.slug}`,
                    onDeleteGallery: ($event: any) => (_ctx.galleryDeleteConfirmation(gallery.slug)),
                    onPinGallery: _ctx.doPinGallery,
                    onUnpinGallery: _ctx.doUnpinGallery
                  }, null, 8, ["gallery", "onDeleteGallery", "onPinGallery", "onUnpinGallery"]))
                }), 128)),
                (!_ctx.hasGalleries && !_ctx.isLoadingGalleries && !_ctx.isSearching)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openCreateGallery && _ctx.openCreateGallery(...args))),
                      class: "lg:col-span-2 lg:col-start-2 relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 cursor-pointer"
                    }, [
                      _cache[17] || (_cache[17] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "1.5",
                        stroke: "currentColor",
                        class: "mx-auto size-12 text-gray-400"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
                        })
                      ], -1)),
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('home.empty_gallery.text')), 1),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('home.empty_gallery.button')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hasGalleries && !_ctx.isLoadingGalleries && _ctx.isSearching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _cache[18] || (_cache[18] = [
                      _createElementVNode("div", { class: "flex justify-center p-8 text-center" }, [
                        _createElementVNode("p", { class: "text-sm text-gray-500" }, "За вашим запитом пошуку галерей не знайдено")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoadingGalleries && !_ctx.showDeletedList && _ctx.layout === 'list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_GalleryListLoaderComponent)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoadingGalleries && _ctx.showDeletedList && _ctx.deletedGalleries.length && _ctx.layout === 'list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_GalleryListComponent, {
                  galleries: _ctx.deletedGalleries,
                  "is-loading": _ctx.isLoadingGalleries,
                  "is-deleting": true,
                  onRestoreGallery: _ctx.restore,
                  onDeleteGallery: _ctx.deleteFromDeletedList
                }, null, 8, ["galleries", "is-loading", "onRestoreGallery", "onDeleteGallery"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoadingGalleries && !_ctx.showDeletedList && _ctx.layout === 'list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_GalleryListComponent, {
                  galleries: _ctx.galleries,
                  "is-loading": _ctx.isLoadingGalleries,
                  "is-search-empty": _ctx.galleries.length === 0 && _ctx.isSearching,
                  onDeleteGallery: _ctx.galleryDeleteConfirmation,
                  onPinGallery: _ctx.doPinGallery,
                  onUnpinGallery: _ctx.doUnpinGallery
                }, null, 8, ["galleries", "is-loading", "is-search-empty", "onDeleteGallery", "onPinGallery", "onUnpinGallery"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, null, 512),
          (_ctx.isLoadingMore && !_ctx.showDeletedList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[19] || (_cache[19] = [
                _createElementVNode("svg", {
                  class: "size-6 animate-spin text-gray-400",
                  viewBox: "0 0 24 24",
                  fill: "none"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z"
                  })
                ], -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.galleriesHasMore && !_ctx.isLoadingMore && !_ctx.isLoadingGalleries && !_ctx.showDeletedList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args))),
                  type: "button",
                  class: "rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-xs ring-1 ring-gray-200 ring-inset hover:bg-gray-50 cursor-pointer"
                }, _toDisplayString(_ctx.$t('home.load_more')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_InformationCircleIcon, {
                    class: "size-5 text-royal-blue-400",
                    "aria-hidden": "true"
                  })
                ]),
                _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"ml-3 flex-1 md:flex md:justify-between\"><p class=\"text-sm text-royal-blue-700\">Оновлений дизайн та додаткові функції вже доступні.</p><p class=\"mt-3 text-sm md:mt-0 md:ml-6\"><a href=\"#\" class=\"font-medium whitespace-nowrap text-royal-blue-700 hover:text-royal-blue-600\"> Деталі <span aria-hidden=\"true\"> →</span></a></p></div>", 1))
              ])
            ]),
            (_ctx.user && _ctx.user.storage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", {
                        class: _normalizeClass([{
                                      'bg-yellow-500': _ctx.storageUsedPercent >= 90 && _ctx.storageUsedPercent < 100,
                                      'bg-red-500': _ctx.storageUsedPercent >= 100,
                                      'bg-royal-blue-500': _ctx.storageUsedPercent < 90
                                    }, "h-full rounded"]),
                        style: _normalizeStyle({ width: `${Math.min(_ctx.storageUsedPercent, 100)}%` })
                      }, null, 6)
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _cache[21] || (_cache[21] = _createElementVNode("span", null, "Використано:", -1)),
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.storageUsed), 1),
                        _createTextVNode(" / " + _toDisplayString(_ctx.storageLimit), 1)
                      ])
                    ]),
                    (_ctx.storageUsedPercent >= 90 || _ctx.user.subscription_type === 'free')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "/subscription",
                          class: "bg-royal-blue-500 hover:bg-blue-700 text-white w-full mt-2 py-2 px-4 rounded-lg text-center block"
                        }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode(" Збільшити сховище ")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_DeleteGalleryConfirmationModalComponent, {
      open: _ctx.isDeletingConfirmation,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDeletingConfirmation = false)),
      onConfirmAction: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deletingConfirmationGallerySlug ? _ctx.doDeleteGallery(_ctx.deletingConfirmationGallerySlug) : null)),
      title: _ctx.$t('gallery_settings.delete_gallery.title'),
      message: _ctx.$t('gallery_settings.delete_gallery.confirmation'),
      secondMessage: _ctx.deletingConfirmationWarning,
      buttonText: _ctx.$t('gallery_settings.delete_gallery.button'),
      isLoading: _ctx.isDeletingGallery
    }, null, 8, ["open", "title", "message", "secondMessage", "buttonText", "isLoading"]),
    _createVNode(_component_DeleteGalleryConfirmationModalComponent, {
      open: _ctx.isDeletingFromDeletesListConfirmation,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDeletingFromDeletesListConfirmation = false)),
      onConfirmAction: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deletingConfirmationGallerySlug ? _ctx.doDeleteGallery(_ctx.deletingConfirmationGallerySlug) : null)),
      title: _ctx.$t('gallery_settings.delete_gallery.title'),
      message: _ctx.$t('home.delete_confirmation'),
      secondMessage: _ctx.deletingConfirmationWarning ? _ctx.$t('home.delete_confirmation_info') + ' ' + _ctx.deletingConfirmationWarning : _ctx.$t('home.delete_confirmation_info'),
      buttonText: _ctx.$t('gallery_settings.delete_gallery.button'),
      isLoading: _ctx.isDeletingGallery
    }, null, 8, ["open", "title", "message", "secondMessage", "buttonText", "isLoading"]),
    _createVNode(_component_CreateGalleryComponent, {
      open: _ctx.isCreateGalleryOpen,
      onClose: _ctx.closeCreateGallery
    }, null, 8, ["open", "onClose"])
  ], 64))
}